export type WidgetDef = { key: string; label: string; permission: `widget:${string}` };

// Only list of dashboard widgets. Backend mirror: backend/app/core/commons/dashboard_widgets.py.
export const WIDGETS = [
    { key: 'myCards', label: 'My cards', permission: 'widget:my_cards' },
    { key: 'generatedQuotes', label: 'Generated quotes', permission: 'widget:generated_quotes' },
    { key: 'convertedQuotes', label: 'Converted quotes', permission: 'widget:converted_quotes' },
    { key: 'leadsConverted', label: 'Leads converted', permission: 'widget:leads_converted' },
    { key: 'pendingToSend', label: 'Pending to send', permission: 'widget:pending_to_send' },
    { key: 'quotingSloped', label: 'Quoting — Sloped', permission: 'widget:quoting_sloped' },
    { key: 'quotingFlat', label: 'Quoting — Flat', permission: 'widget:quoting_flat' },
    { key: 'quotingMixed', label: 'Quoting — Mixed', permission: 'widget:quoting_mixed' },
    { key: 'metricsChart', label: 'Activity chart', permission: 'widget:metrics_chart' },
    { key: 'commissions', label: 'Commissions', permission: 'widget:commissions' },
    { key: 'activeProjects', label: 'Active Projects', permission: 'widget:active_projects' },
    { key: 'quotations', label: 'Quotations', permission: 'widget:quotations' },
    { key: 'quotesPendingFinish', label: 'Quotes Pending to Finish', permission: 'widget:quotes_pending_finish' },
    { key: 'opportunityRange', label: 'Opportunity Range', permission: 'widget:opportunity_range' },
] as const satisfies readonly WidgetDef[];

export type DashboardWidgetKey = (typeof WIDGETS)[number]['key'];
